export default "/template/resource//static/media/img_dengluyichang.5a13e814.png";